import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import inboxUiTranslations from '../src/locales/en/inbox-ui.json';

i18n.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    resources: {
        en: {
            'inbox-ui': inboxUiTranslations,
        },
    },
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
});
export default i18n;
